export const CORECON_READ = 'man.corecon.ui.read';
export const CORECON_MBB_WRITE = 'man.corecon.ui.mbb.write';
export const CORECON_UPLOAD_WRITE = 'man.corecon.ui.upload.write';
export const HEATMAP_READ = 'rio.heatmap.read';
export const CORECON_LOG_DEVICE_WRITE = 'man.corecon.ui.logdevice.write';
export const CORECON_DEV_DEVICE_WRITE = 'man.corecon.ui.devdevicewhitelist.write';
export const CORECON_TEAM = 'man.corecon.team';
